module.exports = __webpack_public_path__ + "static/media/vtulogo.83046d08.png";